import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import URL from '../../../constants/url';
import noDataImg from '../../../images/common/i_3d_no_data_doc.svg';
import style from './ServicePolicy.module.css';
import Skeleton from '@mui/material/Skeleton';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import MSG from '../../../constants/message';


const ServicePolicy = () => {
    const navigate = useNavigate();
    const [policyList, setPolicyList] = useState([]);
    const [isInitialLoading, setIsInitialLoading] = useState(true);

    useEffect(() => {
        //약관 목록 호출
        const getData = async () => {

            const url = `/signup/retrieveHospitalPolicyIdList`;

            await axiosApi.post(url, ["A","B","C","D","E"])
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setPolicyList(res.data.result.result);
                } else {
                    // setToastMessage(res.data.resultMessage);
                    // setToast(true);
                }
                setIsInitialLoading(false);
            })
            .catch(err => {
                console.error("===========> 이용약관 호출 실패  : ", err);
            })
        }

        getData();

    },[]);


    return (
        <>
            <HeadSub title="서비스 약관 및 정책" />

            <div id="sub-content">
                <div className="inner-wrap" data-pad="normal">
                    <div className={style['guide-lists-box']}>
                        <ul>
                            {isInitialLoading && (
                                [...Array(5)].map((_, idx) => (
                                    <li key={`skeleton_${idx}`}>
                                        <p className={style['title']}>
                                            <Skeleton variant="text" width="140px" height={24} style={{ marginBottom: '8px' }} />
                                        </p>
                                    </li>
                                ))
                            )}

                            {!isInitialLoading && policyList.length === 0 && (
                                <li className={style['no-data-box']}>
                                    <div className={style['img-box']}>
                                        <object data={noDataImg} aria-hidden="true" />
                                    </div>
                                    <p>약관 및 정책이 없습니다.</p>
                                </li>
                            )}

                            {!isInitialLoading && policyList.map((item, idx) => (
                                <li key={`policy_${idx}`}
                                    onClick={() => navigate(URL.SERVICE_POLICY_DETAIL, { state: { id: item.id, stplatPolicySeCd: item.stplatPolicySeCd } })}>
                                    <p className={style['title']}>{item.stplatPolicySj}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServicePolicy;